import type { ModulesConfig } from '#types/mappings'

const modules: ModulesConfig = {
  CMPicture: {
    component: 'picture',
    hydration: 'never'
  },
  CMVideo: {
    component: 'video',
    hydration: 'visible'
  },
  P13NExperience: {
    component: 'experiment',
    hydration: 'visible'
  },
  P13NSegmentation: {
    component: 'segmentation',
    hydration: 'visible'
  },
  VfCanvasAccordions: {
    component: 'accordions',
    hydration: 'visible'
  },
  VfCanvasAnchor: {
    component: 'anchor'
  },
  VfCanvasArticleCarousel: {
    component: 'article-carousel'
  },
  VfCanvasArticleGrid: {
    variants: {
      'default': {
        component: 'article-grid',
      },
      'article-grid-v2': {
        component: 'article-grid-v2',
      }
    },
    hydration: 'visible'
  },
  VfCanvasBanner: {
    variants: {
      blurredSplitBanner: {
        component: 'banner-blurred-split'
      },
      imageBanner: {
        component: 'banner-image'
      },
      saleSplitBanner: {
        component: 'banner-sale-split'
      },
      splitBanner: {
        component: 'banner-split'
      },
      thinBanner: {
        component: 'banner-thin'
      },
      blockBelowBanner: {
        component: 'banner-block-below'
      },
      overlayBanner: {
        component: 'banner-overlay'
      },
      videoScrollParallaxBanner: {
        component: 'banner-video-parallax',
        hydrationOptions: {
          observerOptions: { rootMargin: '800px' }
        }
      }
    },
    hydration: 'visible'
  },
  VfCanvasBannerCarousel: {
    component: 'collection',
  },
  VfCanvasBenefitBar: {
    component: 'benefit-bar',
    hydration: 'visible'
  },
  VfCanvasBloomreachProductRecommendations: {
    component: 'bloomreach-recommendations',
    hydration: 'visible',
    hydrationOptions: {
      observerOptions: { rootMargin: '200px' }
    },
  },
  VfCanvasCTAButton: {
    component: 'cta-button',
    hydration: 'visible'
  },
  VfCanvasCTAButtonCollection: {
    component: 'cta-button-collection',
  },
  VfCanvasCategoryCard: {
    component: 'category-card',
    hydration: 'visible'
  },
  VfCanvasCategoryCardCollection: {
    component: 'collection',
  },
  VfCanvasComingSoon: {
    component: 'coming-soon',
    hydration: 'interaction'
  },
  VfCanvasDialog: {
    variants: {
      'default': {
        component: 'dialog'
      },
      'generic-container': {
        component: 'dialog-generic'
      }
    },
  },
  VfCanvasEspotBanner: {
    component: 'banner-espot',
    hydration: 'visible'
  },
  VfCanvasEventCollection: {
    component: 'event-collection'
  },
  VfCanvasFilterBy: {
    component: 'filter-by',
    hydration: 'visible'
  },
  VfCanvasFooterItem: {
    component: 'footer-item',
    hydration: 'visible'
  },
  VfCanvasHero: {
    hydration: 'visible',
    variants: {
      default: {
        component: 'hero'
      },
      blockBelowHero: {
        component: 'hero-block-below'
      },
      productOverlayHero: {
        component: 'hero-product-overlay'
      }
    }
  },
  VfCanvasIconAndTextCollection: {
    variants: {
      'default': {
        component: 'icon-and-text-collection',
      },
      'product-features': {
        component: 'product-features',
      }
    },
    hydration: 'interaction'
  },
  VfCanvasLinkedCard: {
    component: 'linked-card',
    hydration: 'visible'
  },
  VfCanvasLinkedCardCollection: {
    variants: {
      default: {
        component: 'collection',
      },
      verticalList: {
        component: 'collection-vertical-list'
      },
      twoCardParallax: {
        component: 'collection-parallax',
      },
      twoColumnGallery: {
        component: 'collection-column-gallery',
      },
      galleryParallax: {
        component: 'collection-parallax',
      }
    }
  },
  VfCanvasLoyaltyPlaceholder: {
    component: 'loyalty-banner',
    hydration: 'visible'
  },
  VfCanvasMegaMenu: {
    component: 'mega-menu',
    hydration: 'visible'
  },
  VfCanvasMegaMenuBanner: {
    component: 'banner-menu',
    hydration: 'visible'
  },
  VfCanvasMegaMenuL1: {
    component: 'mega-menu-l1',
    hydration: 'visible'
  },
  VfCanvasMegaMenuL2: {
    component: 'mega-menu-l2',
    hydration: 'visible'
  },
  VfCanvasMegaMenuL3: {
    component: 'mega-menu-l3',
    hydration: 'visible'
  },
  VfCanvasMegaMenuMobile: {
    component: 'mega-menu-mobile',
    hydration: 'visible'
  },
  VfCanvasMegaMenuVisualSelector: {
    component: 'mega-menu-visual-selector',
    hydration: 'visible'
  },
  VfCanvasMultilinkCard: {
    component: 'multi-link-card',
    hydration: 'visible'
  },
  VfCanvasMultilinkCollection: {
    component: 'collection',
    hydration: 'visible'
  },
  VfCanvasNewsletterSignup: {
    component: 'newsletter-signup',
    hydration: 'visible'
  },
  VfCanvasPopUp: {
    component: 'pop-up',
    hydration: 'visible'
  },
  VfCanvasProductGridCollection: {
    component: 'product-grid'
  },
  VfCanvasProductFinder: {
    component: 'product-finder',
    hydration: 'visible'
  },
  VfCanvasProductUpsell: {
    component: 'product-upsell',
    hydration: 'visible'
  },
  VfCanvasPromoBar: {
    component: 'promo-bar',
    hydration: 'visible'
  },
  VfCanvasPromoBarMessage: {
    component: 'promo-bar-message',
    hydration: 'visible'
  },
  VfCanvasRichText: {
    component: 'rich-text',
    hydration: 'visible'
  },
  VfCanvasSecondaryNav: {
    component: 'secondary-navigation',
    hydration: 'visible'
  },
  VfCanvasShopTheLookCollection: {
    variants: {
      mosaic: {
        component: 'shop-the-look-mosaic'
      },
      galleryParallax: {
        component: 'shop-the-look-gallery'
      }
    }
  },
  VfCanvasSignIn: {
    component: 'sign-in',
    hydration: 'interaction'
  },
  VfCanvasSpacer: {
    component: 'spacer',
    hydration: 'never'
  },
  VfCanvasThinBanner: {
    component: 'thin-banner',
    hydration: 'visible'
  },
  VfCanvasUgc: {
    component: 'ugc',
    hydration: 'visible'
  },
  VfCanvasVideoPlayer: {
    component: 'video-player',
    hydration: 'visible'
  },
  VfCanvasVisualSelectorCollection: {
    component: 'mega-menu-visual-selector-collection',
    hydration: 'visible'
  }
}

export default modules
